import styled from "styled-components";
import { TABLET_MAX } from "../../styles/breakpoints";

export const TopBarContainer = styled.div`
  display: none;

  @media (max-width: ${TABLET_MAX}px) {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: flex-end;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    height: 80px;
    padding: 12px 16px;
    gap: 110px;
    background: #ffffff;
    z-index: 1040;
    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.06);
  }
`;

export const LogoArea = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  width: 143px;
  height: 28px;
  flex: none;
  flex-grow: 0;
`;

export const LogoIconImg = styled.img`
  height: 28px;
  width: auto;
`;

export const LogoTextImg = styled.img`
  height: 18px;
  width: auto;
`;

/* Right-side cluster: notification bell + avatar */
export const RightArea = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
  gap: 20px;
  flex: none;
  flex-grow: 0;
`;

/* Bell icon wrapper — 20×20, relative so the dot can be absolutely positioned */
export const BellWrapper = styled.div`
  position: relative;
  width: 20px;
  height: 20px;
  flex: none;
  flex-grow: 0;
  cursor: pointer;
`;

/* Purple notification dot */
export const NotifDot = styled.div`
  position: absolute;
  width: 8px;
  height: 8px;
  left: 13px;
  top: 1px;
  background: #6c2ef2;
  border: 1px solid #ffffff;
  border-radius: 50%;
  z-index: 1;
`;

export const ProfileAvatar = styled.img`
  width: 24px;
  height: 24px;
  border-radius: 50%;
  object-fit: cover;
  border: 1px solid #ffffff;
  cursor: pointer;
  flex: none;
  flex-grow: 0;
`;

export const ProfileInitials = styled.div`
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background: ${({ color }) => color || "#3b3f48"};
  color: #fff;
  font-size: 11px;
  font-weight: 700;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #ffffff;
  cursor: pointer;
  flex-shrink: 0;
`;
